import { LanguageOptions } from "../../models/LanguageOptions";
import LangPrefPage2 from "./updateLanguage2";
import { useTranslation } from "react-i18next";

function UpdateLanguage1() {
  const { t } = useTranslation();
  const options = new LanguageOptions().options.map((option) => {
    return {
      group: "language",
      className: "language_selection",
      value: option.code,
      text: option.name,
      id: option.code,
    };
  });

  const data = {
    question: t("onboard.LANG_PREF.question"),
    choices: options,
  };

  return data === undefined ? (
    <div>Loading...</div>
  ) : (
    <LangPrefPage2 data={data} />
  );
}

export default UpdateLanguage1;
